var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternKeyword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7h16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17h14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternKeyword);
export default __webpack_public_path__ + "static/media/pattern-keyword.80efeb3a95b8578016f39333b320f445.svg";
export { ForwardRef as ReactComponent };